<template>
  <div
    class="agenda-item"
    @click="handleClickWholeItem"
  >
    <div class="agenda-item__header">
      <div class="agenda-item__time">
        <i class="fa-regular fa-clock"></i>
        <span>{{ timeSlot.period_formatted }}</span>
      </div>
      <div class="agenda-grouped-item__count">
        {{ sessions.length }} {{ sessions.length === 1 ? 'session' : 'sessions' }}
      </div>
    </div>

    <div class="agenda-item__body" v-if="topics?.length">
      <div class="agenda-item__info">
        <!-- topics -->
        <span key="topics" v-for="(topic, topicIndex) in topics" :key="`session-topic-${topicIndex}`">
          <marked-status
            style="margin-bottom: 7px;"
            :withBorder="true"
          >{{ topic }}</marked-status>&nbsp;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import MarkedStatus from "../../../components/ui/MarkedStatus/index.vue";

export default {
  name: 'AgendaGroupedItem',
  components: {MarkedStatus},
  props: {
    timeSlot: {
      type: Object,
      required: true,
    },
    sessions: {
      type: Array,
      required: true,
    },
    topics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
    };
  },
  methods: {
    handleClickWholeItem() {
      this.$emit('filter-by-time', {
        start: this.timeSlot.start_at_formatted,
        end: this.timeSlot.end_at_formatted,
        dayId: this.timeSlot.day_id,
        date: this.timeSlot.happens_at,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.agenda-item {
  border: 1px solid var(--attendee-border-color);
  background-color: var(--attendee-card-color);
  border-radius: var(--attendee-card-border-radius);
  margin-bottom: var(--attendee-gap-lg);
  transition: .3s all;
  cursor: pointer;

  //&:hover {
  //  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  //  transform: translateY(-2px);
  //
  //  .agenda-item__header {
  //    background-color: var(--attendee-bg-secondary, #e9ecef);
  //  }
  //}

  @media (max-width: 900px) {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid var(--attendee-border-color);
    margin-bottom: 0;
    padding-bottom: var(--attendee-gap-md);
  }

  &__body {
    padding: var(--attendee-gap-md) var(--attendee-gap-md) var(--attendee-gap-sm) var(--attendee-gap-md);

    @media (max-width: 900px) {
      padding: var(--attendee-gap-sm) var(--attendee-gap-md) 0 var(--attendee-gap-md);
    }
  }

  &__header {
    background-color: var(--attendee-background-color);
    border-top-right-radius: var(--attendee-card-border-radius);
    border-top-left-radius: var(--attendee-card-border-radius);
    padding: var(--attendee-gap-sm) var(--attendee-gap-md);
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.2s ease;

    @media (max-width: 900px) {
      border-radius: 0;
    }
  }

  &__time {
    color: var(--attendee-text-primary-color);
    display: flex;
    gap: 10px;
    align-items: center;
    font-weight: 600;
    font-size: 16px;

    i {
      color: var(--attendee-primary-color, #007bff);
      font-size: 18px;
    }

    @media (max-width: 900px) {
      font-size: 14px;

      i {
        font-size: 16px;
      }
    }
  }

  .agenda-grouped-item__count {
    font-size: 14px;
    color: var(--attendee-text-secondary-color, #666);
    font-weight: 500;

    @media (max-width: 900px) {
      font-size: 13px;
    }
  }

  .agenda-item__info {
    font-size: 16px;
    color: var(--attendee-text-primary-color);

    @media (max-width: 900px) {
      font-size: 14px;
    }
  }
}
</style>